export const AuditTrailType = {
  Visit: 1,
  Treatment: 2,
  NPA: 3,
};
